<template>
  <div v-if="!isPrint">
    <!--    기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" />

    <!-- 점검정보 -->
    <div>
      <h5 class="my-4"><i class="dot"></i> 점검정보</h5>
      <div class="writeGridContainer">
        <div>
          <div>점검일</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputA_1 }}</p>
          <date-selector v-else :readonly="board.readonly" v-model="form.inputA_1" />
        </div>
        <div>
          <div>소속명</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputA_2 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputA_2" />
        </div>
        <div>
          <div>점검자</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputA_3 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputA_3"/>
        </div>
      </div>
    </div>

    <table-inspect-merge
      :is-print="isPrint"
      :is-readonly="board.readonly"
      contentBefore="·"
      :title="form.inspectTitle"
      :table-header-title="form.inspectTableHeaderTitle"
      :table-header-note="[{ text: '비고', width: 320 }]"
      v-model="form.inspectList"
      class="mt-5"/>


    <!-- 결재란 -->
    <div class="mt-8">
      <div>
        <h5><i class="dot"></i> 결재란</h5>
      </div>
      <name-with-signature-row label-name="작성자" :name.sync="form.sign1.name" :signature.sync="form.sign1.sign" />
      <name-with-signature-row label-name="검토자" :name.sync="form.sign2.name" :signature.sync="form.sign2.sign" />
      <name-with-signature-row label-name="회람자" :name.sync="form.sign3.name" :signature.sync="form.sign3.sign" />
      <name-with-signature-row label-name="승인자" :name.sync="form.sign4.name" :signature.sync="form.sign4.sign" />
    </div>

    <!--    사진대지-->
    <photo-upload-grid-module
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :is-print="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="신축현장 점검"
    />

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
  <print v-else :board="board" :form="form"/>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import TableInspectMerge from "@/components/TableInspectMerge";
import DateSelector from "@/components/selector/DateSelector";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";
import CompanySelector from "@/components/selector/CompanySelector";

import inspectData from "./inspectData";
import SignField from "@/components/SignField.vue";
import NameWithSignatureRow from "@/components/NameWithSignatureRow.vue";
import Pagination from "@/components/Pagination.vue";
import Print from "./Print.vue";

export default {
  components: {
    Print,
    Pagination,
    NameWithSignatureRow,
    SignField,
    FieldSelectModule,
    FileUploadModule,
    TableInspectMerge,
    DateSelector,
    DisasterClassSelector,
    CompanySelector,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  data() {
    return {
      form: {
        stdInfo: {},

        inputA_1: "",
        inputA_2: "",
        inputA_3: "",

        inspectList: inspectData,
        inspectTitle: "산업용로봇 안전 점검표",
        inspectTableHeaderTitle: "점검항목",

        photoList: [],
        fileList: [],

        sign1: {
          name: "",
          sign: "",
        },
        sign2: {
          name: "",
          sign: "",
        },
        sign3: {
          name: "",
          sign: "",
        },
        sign4: {
          name: "",
          sign: "",
        },
      },
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  computed: {
  },
  methods: {
  },
};
</script>

